const TYPE_OFFICE = 0;
const TYPE_GUIDELINES_AND_PUBLICATIONS_COUNCIL = 1;
const TYPE_COMMITTEE_USER = 2;
const TYPE_NATIONAL_DELEGATE = 3;
const TYPE_EXTERNAL = 4;
const TYPE_INTERNAL_GROUPS_OFFICER = 5;


export class UserRoles {
  static get office() {return TYPE_OFFICE}
  static get guidelinesAndPublicationsCouncil() {return TYPE_GUIDELINES_AND_PUBLICATIONS_COUNCIL}
  static get committeeUser() {return TYPE_COMMITTEE_USER}
  static get nationalDelegate() {return TYPE_NATIONAL_DELEGATE}
  static get external() {return TYPE_EXTERNAL}
  static get internalGroupsOfficer() {return TYPE_INTERNAL_GROUPS_OFFICER}
}
